
<template> 
    <div class="row g-6 g-xl-9" >  
        <div class="col-12 col-md-12 col-xl-12"> 
            <Index  :perfis="perfis"/>  
        </div>
    </div>
</template>

<script lang="ts">
    import Index from   "./_Index.vue"  
    import { Options, Vue } from "vue-class-component";   
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 

    @Options({
        name: "TurmaQuantidadeReprovacoes",
        components: { Index },  
    }) 
    export default class TurmaQuantidadeReprovacoes extends Vue {  
        @authStore.Getter
		public perfis!: any  
    }
</script>
 